/**
 * 通过appKey反向映射channel，用于channel参数下线过渡期使用
 */

import { msLocalStorage } from '@common/utils/cache';

// appKey与channel映射关系，其他未列举的默认appKey与channel一致，全量见：https://weikezhijia.feishu.cn/wiki/Dm0owSSNwi87p2k03iQcWsHJnsg
enum APPKEY_CHANNEL_ENUM {
  'MS_IOS' = 'msjrapp', //马上金融APP
  'MS_ANDROID' = 'msjrapp', //马上金融APP
  'MS_HARMONY' = 'msjrapp', //马上金融APP鸿蒙

  'SYH_IOS' = 'SYH-APP', //顺逸花APP
  'SYH_ANDROID' = 'SYH-APP', //顺逸花APP
  'AYH_HARMONY' = 'SYH-APP', //顺逸花APP鸿蒙系统
  'AYH_LITE_IOS' = 'AYHLITE-APP', //顺逸花APP极速版

  'newzy_ANDROID' = 'LHH-APP', //优逸花APP
  'newzy_IOS' = 'LHH-APP', //优逸花APP
  'newzy_LITE_IOS' = 'LHHLITE-APP', //优逸花APP极速版（马甲包）

  'MS_LITE_ANDROID' = 'MSJRLITE-APP', //马上分期APP安卓端
  'MS_LITE_IOS' = 'MSJRLITE-APP', //马上分期APPIOS

  'MS_WeChat' = 'mswechat', //马上金融微信公众号
  'AYHofficial_Wechat_loan' = 'MS_WeChat_AYH', //顺逸花官方借款平台公众号

  'Alipaysw_AYH' = 'SYH-SW', //顺逸花支付宝服务窗
  'alipaysw' = 'ALIPAY-SW', //马上金融服务窗
}

/**
 * 根据appKey获得channel
 */
export default (appKey = msLocalStorage.get('PUBLIC_APPKEY') ?? '') => {
  return APPKEY_CHANNEL_ENUM[appKey] ?? appKey;
};
